import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ItemsList').create(({ theme }) => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridAutoRows: '70px',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '10px',
    paddingTop: '0px',
    paddingBottom: '130px',
  },

  listItem: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(180deg, #0E0E0E 0%, #747474 100%)',
    borderRadius: '9px',
    border: '2px solid transparent',

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },

    '&:after': {
      content: '""',
      width: '100%',
      height: '100%',
      position: 'absolute',
      borderRadius: '8px',
      border: '2px solid #74747490',
      zIndex: '20',
    },

    '&[data-forsale="true"]': {
      border: '3px solid #4A6BFC',
    },
  },

  sale: {
    display: 'flex',
    position: 'absolute',
    bottom: 0,
    textAlign: 'center',
    alignSelf: 'center',
    backgroundColor: theme.colors.text.link,
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '4px 10px',
    fontSize: theme.sizes.texts.fontSize.xs,
    fontWeight: '470',
    color: 'white',
    textTransform: 'uppercase',
    fontFamily: 'Inter',
    fontStyle: 'normal',
  },

  noItems: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    color: 'white',
    fontFamily: 'Inter',
    fontWeight: '470',
  },

  noItemsText: {
    width: '100%',
    textAlign: 'center',
  },

  img: {
    border: '1px solid transparent',
    borderRadius: '7px',
    borderImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.12) 0%, rgba(0, 0, 0, 0.12) 100%);',
  },
}))
